var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "stroke",
    d: "M12.1378 13.2842C11.8053 12.3533 11.0725 11.5308 10.0531 10.9442C9.03373 10.3575 7.78473 10.0395 6.49983 10.0395C5.21493 10.0395 3.96593 10.3575 2.94655 10.9442C1.92717 11.5308 1.19437 12.3533 0.861816 13.2842M9.41828 4.20263C9.41828 5.81445 8.11164 7.12108 6.49983 7.12108C4.88801 7.12108 3.58138 5.81445 3.58138 4.20263C3.58138 2.59081 4.88801 1.28418 6.49983 1.28418C8.11164 1.28418 9.41828 2.59081 9.41828 4.20263Z",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.563f24dc547226a39b289c64c202d13c.svg";
export { ForwardRef as ReactComponent };